/**
 * Where each agency opens. CADE opens on the decision search: that is what its
 * subscribers come to do, and the overview is a coverage report. Until a reader
 * dismisses it, CADE opens on its first-steps page instead (`/cade/start`).
 */
export const AGENCY_LANDINGS: readonly (readonly [agency: string, path: string])[] = [
  ['anatel', '/anatel/overview'],
  ['aneel', '/aneel/overview'],
  ['cade', '/cade/decisions'],
  ['ans', '/ans/overview'],
  ['ibama', '/ibama/overview'],
  ['bacen', '/bacen/overview'],
  ['cvm', '/cvm/overview'],
];

export const CADE_START = '/cade/start';

const START_DISMISSED_KEY = 'cade.start.dismissed';

/**
 * Whether this viewer dismissed the CADE first-steps page. A per-browser
 * convenience, never state that matters: storage that is blocked or cleared
 * simply shows the page again.
 */
export function startDismissed(): boolean {
  try {
    return window.localStorage.getItem(START_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function setStartDismissed(dismissed: boolean): void {
  try {
    if (dismissed) window.localStorage.setItem(START_DISMISSED_KEY, '1');
    else window.localStorage.removeItem(START_DISMISSED_KEY);
  } catch {
    // Blocked storage: the page simply keeps opening first.
  }
}

/** The first screen of the first agency the account may open, or the workspace. */
export function landingFor(
  mayAccess: (agency: string) => boolean,
  dismissed: boolean = startDismissed(),
): string {
  const found = AGENCY_LANDINGS.find(([agency]) => mayAccess(agency));
  if (!found) return '/workspace';
  if (found[0] === 'cade' && !dismissed) return CADE_START;
  return found[1];
}
